import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const Bamba: EmploymentType = {
	company: 'Bamba',
	position: 'Founder & CTO',
	objective: 'A company that provided tools for data collection in emerging markets.',
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/Bamba.png',
};
